"use client";

import {
  useModal,
  useWallet,
  useAccount,
  useWalletState,
} from "@getpara/react-sdk";
import { useEffect } from "react";
import { ArrowIcon } from "@/icons";
import { useIsRestrictedRegion } from "@/lib/localization";
import { StyledButton } from "@/components/common/styledButton";

export function WalletConnectButton({
  WalletConnectName = "Connect Wallet",
  disabled = false,
}: {
  WalletConnectName?: string;
  disabled?: boolean;
}) {
  const { openModal } = useModal();
  const { data: wallet } = useWallet();
  const { isConnected } = useAccount();
  const { setSelectedWallet } = useWalletState();
  const isRegionRestricted = useIsRestrictedRegion();

  // Check if user is in a restricted region or explicitly disabled
  const isDisabled = disabled || isRegionRestricted;

  useEffect(() => {
    if (isConnected && wallet?.type !== "EVM") {
      setSelectedWallet({ id: "default", type: "EVM" });
    }
  }, [isConnected, wallet, setSelectedWallet]);

  const handleClick = () => {
    if (!isDisabled) {
      openModal();
    }
  };

  if (!wallet?.address || !isConnected) {
    return (
      <StyledButton
        onClick={handleClick}
        className="uppercase"
        disabled={isDisabled}>
        {WalletConnectName}
        {!isDisabled && <ArrowIcon />}
      </StyledButton>
    );
  }

  const truncatedAddress = `${wallet.address.slice(0, 6)}...${wallet.address.slice(-4)}`;

  return (
    <StyledButton onClick={handleClick} disabled={isDisabled}>
      {truncatedAddress}
    </StyledButton>
  );
}
